import React from "react"
import cx from "classnames"

import { Detail, H1 } from "../../elements"
import { Breadcrumb } from "../../compositions"
import { formatdate } from "../../../helpers"
import { GraphCms_Page } from "graphql-types"

type Props = {
  className?: string
  title: string
  page: GraphCms_Page
}

const PageHeader = ({ className, page, title }: Props) => {
  let createdAt = formatdate(new Date(page.createdAt))

  return (
    <div className={cx(className)}>
      <div className="bg-gradient">
        <div className="max-w-screen-md mx-auto py-3 px-4">
          <Breadcrumb breadcrumb={page.breadcrumb} />
        </div>
      </div>
      <div className="relative max-w-screen-md mx-auto py-8 px-4">
        <H1 className="text-5xl AvenirLTProBlackOblique mb-3">{title}</H1>
        <Detail className="text-sm font-regular">{createdAt}</Detail>
      </div>
    </div>
  )
}

export default PageHeader
